import { h } from 'preact'

export const ReassuranceBoutique = (props) => {
   const { title, items, cacheKey } = props
   return (
      <div class="container-fluid">
         <div data-testid="bande-reassurance-boutique" class="row mt-md-4 reassurance-boutique" data-cache-key={cacheKey}>
            <div class="col-12">
               <h2 >{title}</h2>
            </div>
            {items.map((item, index) => (
               <div
                  class="col-12 col-md-4 mb-2 d-flex lien-composite-before"
                  data-testid={`reassurance-boutique${index + 1}`}
                  data-pdb-zid={item.CTA.analytics.pdbZid}
                  data-pdb-sc={item.CTA.analytics.pdbSc}
                  data-pdb-idc={item.CTA.analytics.pdbIdc}
                  data-pdb-vi={item.CTA.analytics.pdbVi}
                  data-oevent-category={item.CTA.analytics.oeventCategory}
                  data-oevent-action={item.CTA.analytics.oeventAction}
                  data-oevent-label={item.CTA.analytics.oeventLabel}
                  data-oevent-other={item.CTA.analytics.oeventOther}
               >
                  <div class="img-icon">
                     <img loading="lazy" src={item.image} alt={item.imageAlt} width="40" />
                  </div>
                  <div class="d-flex flex-column item flex-1">
                     <h3 class="title mb-0 w-md-75" dangerouslySetInnerHTML={{ __html: addSup(item.title) }}></h3>
                     <p class="w-md-75 mb-0 mb-md-1">{item.description}</p>
                     <a href={item.CTA.URL} class="mt-auto mw-100 link o-link-arrow" target={item.CTA.target}>
                        <strong class="mw-100">{item.CTA.label}</strong>
                     </a>
                  </div>
               </div>
            ))}
         </div>
      </div>
   )
}

const addSup = (text) => {
    return text.replace('(1)', '<sup>(1)</sup>')
}
